// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 272) return "static/chunks/272-14feda325ab408c6.js";
	if (chunkId === 471) return "static/chunks/471-4dfd94fc58904d2b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3922":"4f2c60ebd3778c10","6112":"ea2c8ffe22bfe042"}[chunkId] + ".js";
};